import { render, staticRenderFns } from "./editor.vue?vue&type=template&id=abb23e22&"
import script from "./editor.vue?vue&type=script&lang=js&"
export * from "./editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\gongfeng\\CVSCRM_CODE\\scrm_manage_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('abb23e22')) {
      api.createRecord('abb23e22', component.options)
    } else {
      api.reload('abb23e22', component.options)
    }
    module.hot.accept("./editor.vue?vue&type=template&id=abb23e22&", function () {
      api.rerender('abb23e22', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/editor/editor.vue"
export default component.exports